import React from 'react';
import shape from '../../images/shapes/shape_poligon.svg';

const AboutUs = () => {
    return (
        <section className="about_us_section section_space section_decoration">
            <div className="container">
                <div className="row justify-content-center" >
                    <div className="col-lg-10">
                        <div className="ico_heading_block" data-aos="fade-up" data-aos-duration="600">

                        </div>
                        <ul className="about_ico_block unordered_list_block" >
                            <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100">
                                <div className="about_feature_item">
                                    <h3 className="title_text">
                                        Более 5 лет в арбитраже трафика
                                    </h3>
                                </div>
                            </li>
                            <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="200">
                                <div className="about_feature_item">
                                    <h3 className="title_text">
                                        Работаем с топовыми рекламодателями в СНГ, Европе и Латинской Америке
                                    </h3>
                                </div>
                            </li>
                            <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="300">
                                <div className="about_feature_item">
                                    <h3 className="title_text">
                                        Своя внутренняя команда media buyers, дизайнеров и аналитиков
                                    </h3>
                                </div>
                            </li>
                            <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="400">
                                <div className="about_feature_item">
                                    <h3 className="title_text">
                                        Собственные разработки: системы трекинга и антибан решения
                                    </h3>
                                </div>
                            </li>
                            <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="500">
                                <div className="about_feature_item">
                                    <h3 className="title_text">
                                        Подход: прозрачность, эффективность, доверие
                                    </h3>
                                </div>
                            </li>
                        </ul>
                        <div className="text-center mt-4" data-aos="fade-up" data-aos-duration="600" data-aos-delay="600" style={{ fontFamily: 'Palqa', fontSize: 17 }}>
                            <p className="info_description">
                                Мы строим долгосрочные партнёрские отношения и делаем акцент на результат, а не на обещания.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="decoration_item shape_shadow_1">
                <img src={shape} alt="Shape Color Shadow" />
            </div>
            <div className="decoration_item shape_shadow_2">
                <img src={shape} alt="Shape Color Shadow" />
            </div>
        </section>
    );
};

export default AboutUs;